export default function (lovIdentifier) {
  // can return array of object like { identifier: 'data', name: 'Addition data', readonly: true }
  // can be also a checkbox { identifier: 'data', name: 'Addition data', readonly: false, type: 'bool' }
  return []
}
